<template>
  <div>
    <div class="field mb-6 relative">
      <label for="card-number">
        Card number
      </label>
      <div id="card-number" />

      <DrIcon class="absolute w-8" :style="{ right: 0, bottom: 0, margin: 10 }" svg="default-card" />
    </div>

    <div class="flex">
      <div class="field mb-6 flex-grow">
        <label for="card-expiry">
          Expiry
        </label>
        <div id="card-expiry" />
      </div>

      <div class="field mb-6 w-1/3 ml-3 relative">
        <label for="card-expiry">
          CVC
        </label>
        <div id="card-cvc" />

        <DrIcon class="absolute w-8" :style="{ right: 0, bottom: 0, margin: 10 }" svg="card-back" />
      </div>
    </div>

    <div v-if="error" id="card-errors" class="error mb-5 flex items-center">
      <DrIcon svg="close-solid" class="mr-1" />
      <small>{{ error }}</small>
    </div>

    <DrButton
      :loading="loading"
      type="submit"
      class="w-full btn-blue"
      data-cy="btn-submit-creditcard"
      @click.prevent="handlePayment"
    >
      Confirm
    </DrButton>
  </div>
</template>

<script>
import axiosQuoteApi from '@/services/axiosQuoteApi'

export default {
  data () {
    return {
      // eslint-disable-next-line
      stripe: Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY),
      cardNumber: null,
      cardCvc: null,
      cardExpiry: null,
      loading: false,
      error: '',
    }
  },
  computed: {
    convertedToAccountRef: {
      get () {
        return this.$store.getters.getConvertedToAccountRef
      },
      set (value) {
        this.$store.commit('updateConvertedToAccountRef', value)
      },
    },
    quoteTotal: {
      get () {
        return this.$store.getters.getQuoteTotal
      },
      set (value) {
        this.$store.commit('updateTotal', value)
      },
    },
  },

  mounted () {
    const elements = this.stripe.elements()

    this.cardNumber = elements.create('cardNumber')
    this.cardNumber.mount('#card-number')

    this.cardCvc = elements.create('cardCvc')
    this.cardCvc.mount('#card-cvc')

    this.cardExpiry = elements.create('cardExpiry')
    this.cardExpiry.mount('#card-expiry')
  },

  methods: {
    async handlePayment () {
      this.loading = true
      const stripeResponse = await this.stripe.createPaymentMethod('card', this.cardNumber, {})

      // promise is successful with error, sigh
      if (stripeResponse.error) {
        this.error = stripeResponse.error.message
        this.loading = false

        return
      }

      try {
        const response = await axiosQuoteApi.post(`quote/${this.$store.state.quoteId}/stripe/confirm-payment`, {
          payment_method_id: stripeResponse.paymentMethod.id,
        })

        await this.handleServerResponse(response.data)
      } catch (e) {
        this.error = e.response.data.message
        this.loading = false
      }
    },
    async handleServerResponse (data) {
      if (data.requires_action) {
        // Use Stripe.js to handle required card action
        await this.handleAction(data)

        return
      }

      const response = await axiosQuoteApi.post(`quote/${this.$store.state.quoteId}/stripe/checkout`, {
        payment_intent_id: data.payment_intent_id,
        accountReference:
          this.$store.state.portal && this.$store.state.portal.account
            ? this.$store.state.portal.account.reference
            : null,
      })

      // redirect to success
      if (response.data.data.convertedToAccountRef) {
        this.convertedToAccountRef = response.data.data.convertedToAccountRef
        this.quoteTotal = response.data.data.total
        this.loading = false
        this.$router.push('/success')
      }
    },
    async handleAction (data) {
      const stripeResponse = await this.stripe.handleCardAction(data.payment_intent_client_secret)

      // promise is successful with error, sigh
      if (stripeResponse.error) {
        this.error = stripeResponse.error.message
        this.loading = false

        return
      }

      const response = await axiosQuoteApi.post(`quote/${this.$store.state.quoteId}/stripe/confirm-payment`, {
        payment_intent_id: stripeResponse.paymentIntent.id,
      })

      await this.handleServerResponse(response.data)
    },
  },
}
</script>

<style>
.StripeElement {
  @apply text-base appearance-none border border-grey-200 rounded w-full shadow-none px-3 leading-tight bg-white py-3;
}

.StripeElement--focus {
  @apply outline-none shadow-none border-blue-500;
}

.StripeElement--invalid {
  @apply border-red-650;
}

.StripeElement--webkit-autofill {
  @apply bg-white;
}
</style>
